<template>
  <v-text-field
      v-model="inputVal"
      :counter="getLength()"
      :label="label"
      :maxlength="getLength()"
      :rules="[v => (validateUpperCase(v)) || getWarning()]"
      color="primary"
      oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
      v-bind="$attrs"
      v-on:keyup.enter="focusNext($event.target)"
  />
</template>

<script>
/**
 * title: descripcion del input
 * warning: advertencia de la validacion
 * **/
export default {
  name: "input-uppercase",
  props: ['value', 'label', 'from', 'to'],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data: () => ({
    getLength() {
      return this.to;
    },
    getTitle() {
      return `${this.label.replace(/\(\*\)/, '')} es obligatorio`;
    },
    getWarning() {
      if (this.from === this.to) {
        return `${this.label.replace(/\(\*\)/, '')} debe contener ${this.to} caracteres.`
      } else {
        return `${this.label.replace(/\(\*\)/, '')} debe contener entre ${this.from} a ${this.to} caracteres.`
      }
    },
    validateUpperCase(v) {
      if (v && v.length > 0) {
        return new RegExp('^(.{' + this.from + ',' + this.to + '})$').test(v);
      } else {
        return true;
      }
    },
    focusNext(elem) {
      const currentIndex = Array.from(elem.form.elements).indexOf(elem);
      elem.form.elements.item(
          currentIndex < elem.form.elements.length - 1 ?
              currentIndex + 1 :
              0
      ).focus();
    }
  })
}
</script>

<style scoped>

</style>